// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentEditable_container__1CTY3"};